// extracted by mini-css-extract-plugin
export default {"now_playing":"NowPlaying_now_playing__Ow5EI"};